// extracted by mini-css-extract-plugin
module.exports = {"root":"Home_root__3H6Uw","container":"Home_container__1s89M","btn":"Home_btn__1t4lz"};